export const ONLY_TUUN_COUNTRIES = [
	'BD', 'BR', 'CL', 'CD', 'EC', 'GH', 'IN', 'ID', 'KE', 'MQ', 'MU', 'MA', 'NE', 'PE', 'TW', 'TR', 'UG', 'UY', 'ZM', 'NG', 'PH', 'CR', 'GT', 'SV', 'AR', 'KH', 'MO', 'TH',
];

export const PRODUCT_INFO_MESSAGE = {
	countries: ['US', 'CA', 'MX'],
	messages: {
		default: 'products_note',
	},
};

export const HIDE_CUSTOM_ORGANIZATION_COUNTRIES = [];

export const PROMO_UPGRADE_PACKAGES = {
	apprentice: 'apprentice',
	promoter: 'promoter',
	promoter_july_savings_reserve: 'promoter',
	promoter_july_savings_finiti: 'promoter',
	promoter_july_savings_naara: 'promoter',
	influencer: 'influencer',
	ambassador: 'ambassador',
	ambassador_plus: 'ambassador_plus',
	influencer_customizable_summer: 'influencer',
	influencer_l1fe_customizable: 'influencer',
	influencer_select_am_pack: 'influencer',
	influencer_select_pm_pack: 'influencer',
	influencer_select_reserve_pack: 'influencer',
	influencer_select_l1fe_cirqul8_pack: 'influencer',
	influencer_select_l1fe_nmn_pack: 'influencer',
	ambassador_l1fe_customizable: 'ambassador',
	ambassador_prime_am_pack: 'ambassador',
	ambassador_prime_pm_pack: 'ambassador',
	ambassador_prime_reserve_pack: 'ambassador',
	ambassador_prime_l1fe_cirqul8_pack: 'ambassador',
	ambassador_prime_l1fe_nmn_pack: 'ambassador',
	ambassador_plus_l1fe_customizable: 'ambassador',
	promoter_starter_am_pack: 'promoter',
	promoter_starter_pm_pack: 'promoter',
	promoter_starter_reserve_pack: 'promoter',
	promoter_starter_l1fe_cirqul8_pack: 'promoter',
	promoter_starter_l1fe_nmn_pack: 'promoter',
};

export const REASSIGN_PACKAGES = {
	influencer_customizable_summer: 'influencer',
	influencer_l1fe_customizable: 'influencer',
	influencer_select_am_pack: 'influencer',
	influencer_select_pm_pack: 'influencer',
	influencer_select_reserve_pack: 'influencer',
	influencer_select_l1fe_cirqul8_pack: 'influencer',
	influencer_select_l1fe_nmn_pack: 'influencer',
	ambassador_l1fe_customizable: 'ambassador',
	ambassador_prime_am_pack: 'ambassador',
	ambassador_prime_pm_pack: 'ambassador',
	ambassador_prime_reserve_pack: 'ambassador',
	ambassador_prime_l1fe_cirqul8_pack: 'ambassador',
	ambassador_prime_l1fe_nmn_pack: 'ambassador',
	ambassador_plus_l1fe_customizable: 'ambassador',
	promoter_starter_am_pack: 'promoter',
	promoter_starter_pm_pack: 'promoter',
	promoter_starter_reserve_pack: 'promoter',
	promoter_starter_l1fe_cirqul8_pack: 'promoter',
	promoter_starter_l1fe_nmn_pack: 'promoter',
	promoter_july_savings_reserve: 'promoter',
	promoter_july_savings_finiti: 'promoter',
	promoter_july_savings_naara: 'promoter',
};

export const CONFIRMATION_PACKAGE_MESSAGE = [];

// Packages that should not update name
export const NON_SPECIAL_PACKAGES = [];

export const PACKAGE_NAME_BY_FLOW = {
	register: 'enrollment',
	purchase: 'member',
};

export const REPLICATED_LEGS_LINK = ['signup-left', 'signup-right'];

export const MEMBERSHIP_PRICE = 49.95;

export default {};
